// Stamp test ids on the collapsible sections of an ALREADY-SANITIZED help
// article, for ui-runner (which addresses elements by `data-testid` only).
//
// The help sanitizers (nh3 on the server, `sanitizeHelpHtml` here) never let
// `data-testid` through, so article HTML cannot name an app test id. The ids
// are added here instead, after sanitizing, and their values come only from
// this function: `help-section-N` on the N-th `<details>` and
// `help-section-toggle-N` on its `<summary>`, N counting from 1 in document
// order. Positional on purpose: section headings carry dates, so an id
// derived from the heading would change on every build, while "the newest
// section" is always section 1.
//
// DOMParser yields an inert document (no scripts run, nothing loads), the
// same approach `resolveHelpConditions.js` takes.

// The id prefixes. `tools/ui-runner/lint/check_testid_dependencies.py`
// reads these two constants to know the `help-section-<N>` family exists
// (it cannot see a setAttribute call), so keep the names and literal form.
export const SECTION_TESTID_PREFIX = "help-section-";
export const SECTION_TOGGLE_TESTID_PREFIX = "help-section-toggle-";

export function labelHelpSections(sanitizedHtml) {
  if (!sanitizedHtml || typeof sanitizedHtml !== "string") return "";
  // No sections: hand the string back untouched.
  if (!sanitizedHtml.includes("<details")) return sanitizedHtml;

  const doc = new DOMParser().parseFromString(
    `<body>${sanitizedHtml}</body>`,
    "text/html"
  );
  doc.body.querySelectorAll("details").forEach((section, index) => {
    const n = index + 1;
    section.setAttribute("data-testid", `${SECTION_TESTID_PREFIX}${n}`);
    const summary = section.querySelector(":scope > summary");
    if (summary) {
      summary.setAttribute("data-testid", `${SECTION_TOGGLE_TESTID_PREFIX}${n}`);
    }
  });
  return doc.body.innerHTML;
}

export default labelHelpSections;
